import React from "react";
import { useStore } from "effector-react";
import { Box, Typography } from "@material-ui/core";
import { PlayerContainer } from "./player-container";
import { Controls } from "./controls";
import { PlayerTimeRange } from "./timerange";
import { Volume } from "frontend/src/features/change-audio-volume";
import { makeStyles } from "@material-ui/core/styles";
import { $playerCurrentTrack, $playerCurrentTrackSource, } from "frontend/src/domain/player-track-queue";
import { useIsCurrentTrackSourceLoading } from "../../load-player-tracks-source";
import { Skeleton } from "@material-ui/lab";
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        range: (_a = {
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
                width: 400
            },
            _a[theme.breakpoints.up("md")] = {
                width: 500,
            },
            _a[theme.breakpoints.up("lg")] = {
                width: 700,
            },
            _a),
    });
});
var TrackSourceIndicator = function () {
    var trackSource = useStore($playerCurrentTrackSource);
    var text = "";
    if ((trackSource === null || trackSource === void 0 ? void 0 : trackSource.type) === "playlist") {
        text = "\u041F\u043B\u0435\u0439\u043B\u0438\u0441\u0442 - ".concat(trackSource.attributes.title);
    }
    else if ((trackSource === null || trackSource === void 0 ? void 0 : trackSource.type) === "today_timetable") {
        text = "\u0421\u0435\u0442\u043A\u0430 \u0432\u0435\u0449\u0430\u043D\u0438\u044F - ".concat(trackSource.attributes.title);
    }
    return (React.createElement(Box, null,
        React.createElement(Typography, { variant: "caption" }, text)));
};
export var DesktopPlayer = function () {
    var classes = useStyles();
    var track = useStore($playerCurrentTrack);
    var isCurrentTrackSourceLoading = useIsCurrentTrackSourceLoading();
    return (React.createElement(PlayerContainer, null,
        React.createElement(Controls, null),
        React.createElement(Box, { display: "flex", alignItems: "center" },
            React.createElement(Box, { mr: 2 }),
            React.createElement(Box, { className: classes.range },
                React.createElement(Box, { display: "flex", justifyContent: "space-between" },
                    React.createElement(Box, null,
                        isCurrentTrackSourceLoading ? (React.createElement(React.Fragment, null,
                            React.createElement(Skeleton, { width: 65, variant: "text" }),
                            React.createElement(Skeleton, { width: 130, variant: "text" }))) : (React.createElement(React.Fragment, null,
                            React.createElement(Typography, null, track === null || track === void 0 ? void 0 : track.title),
                            React.createElement(Typography, { variant: "caption" }, track && track.type === "public" && track.artist))),
                        React.createElement(TrackSourceIndicator, null))),
                React.createElement(PlayerTimeRange, { track: track }))),
        React.createElement(Volume, null)));
};
